(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusViewEventController', CompanySubscriptionStatusViewEventController);

    CompanySubscriptionStatusViewEventController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom', '$sce', '$location', '$anchorScroll'];

    function CompanySubscriptionStatusViewEventController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom, $sce, $location, $anchorScroll) {
        var vm = this;
        vm.subscriptionTypeList = [];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.lastSubsriptionType = "BASIC";

        CompanySubscriptionStatusCustom.findLastSubscriptionByCurrentCompany().query(function (lastSubsription) {

            // if(lastSubsription)
            // {
            //     vm.lastSubsriptionType =lastSubsription.subscriptionPackage.subscriptionType;
            //     if(vm.lastSubsriptionType=="ECONOMY")
            //     {
            //         vm.subscriptionTypeList=[{type:'ECONOMY',packages:'',isSelected:false},
            //             {type:'ENTERPRISE',packages:'',isSelected:false}];
            //     }
            //     if(vm.lastSubsriptionType=="ENTERPRISE")
            //     {
            //         vm.subscriptionTypeList=[{type:'ENTERPRISE',packages:'',isSelected:false}];
            //
            //     }
            // }
        })

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();
        vm.selectSubscriptionBaseType = selectSubscriptionBaseType;
        vm.selectedSubscriptionType = null;
        vm.isAnyPackageSelected = false;
        vm.availablePackagePeriods = [];
        vm.getAvailablePackagePeriod = getAvailablePackagePeriod;
        vm.makeFeatureDesc = makeFeatureDesc;

        //-------------------------------------
        vm.loadEventSubscriptionTypeList = loadEventSubscriptionTypeList;


        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });

        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();
            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }


                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {


            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: '', isSelected: false}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {

            var classname = "";

            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                classname = "btn-DEFAULT";
            } else {
                classname = "btn-" + type;
            }

            if (vm.isAnyPackageSelected && vm.selectedSubscriptionType != type) {
                classname += " btn-not-selected";
            }

            return classname;
        }

        function packageCardStyle(ptype) {
            if (ptype == undefined)
                return;

            var cls = "package-card-" + ptype.type;
            if (vm.isAnyPackageSelected && ptype.isSelected != true) {
                cls += " package-card-not-selected"
            }

            return cls;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
            });
        }

        function selectSubscriptionBaseType(pType) {

            if (pType == undefined)
                return;

            vm.availablePackagePeriods = [];
            vm.selectedSubscriptionType = pType.type;
            setAllTypeAsUnSelected();
            pType.isSelected = true;
            vm.isAnyPackageSelected = true;

            loadSubscriptionPackages(pType);
            // getAvailablePackagePeriod();

            scrollDown();

        }

        function scrollDown() {
            $location.hash('periodSelection');
            // call $anchorScroll()
            $anchorScroll();
        }

        function setAllTypeAsUnSelected() {
            angular.forEach(vm.subscriptionTypeList, function (type) {
                type.isSelected = false;
            });
        }

        function getAvailablePackagePeriod() {

            if (!vm.isAnyPackageSelected)
                return;

            vm.availablePackagePeriods = [];

            vm.subscriptionTypeList.forEach(function (stype) {

                if (stype.type == vm.selectedSubscriptionType) {
                    vm.availablePackagePeriods = stype.packages;

                    vm.availablePackagePeriods.sort(
                        function (a, b) {
                            if (a.durationDays > b.durationDays)
                                return 1;
                            if (a.durationDays < b.durationDays)
                                return -1;
                            return 0;

                        }
                    );
                }
            });
        }

        function makeFeatureDesc(ptype) {

            var desc = "";


            if (ptype.type == "WEBINAR_BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 30 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 5 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   ماژول کد تخفیف </li>';

            }
            if (ptype.type == "WEBINAR_STANDARD") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 50 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 10 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   ماژول کد تخفیف </li>';
                desc += '<li>   فرم اختصاصی دریافت اطلاعات </li>';

            }
            if (ptype.type == "WEBINAR_PRO") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 100 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 10 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 5 وبکم</strong> فعال </li>';
                desc += '<li>   ماژول کد تخفیف </li>';
                desc += '<li>   فرم اختصاصی دریافت اطلاعات </li>';
                desc += '<li>   ضبط جلسات </li>';
                desc += '<li>   برندینگ اختصاصی </li>';

            }

            if (ptype.type == "CONFERENCE_BASIC") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 30 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 5 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   زمانبندی جلسات </li>';

            }
            if (ptype.type == "CONFERENCE_STANDARD") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 50 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 10 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 5 وبکم</strong> فعال </li>';
                desc += '<li>   زمانبندی جلسات </li>';
                desc += '<li>   برندینگ اختصاصی </li>';

            }
            if (ptype.type == "CONFERENCE_PRO") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    <strong> تا 100 کاربر</strong> در هر جلسه </li>';
                desc += '<li>    <strong> تا 15 ساعت</strong> در ماه </li>';
                desc += '<li>    <strong> 10 وبکم</strong> فعال </li>';
                desc += '<li>   ضبط جلسات </li>';
                desc += '<li>   زمانبندی جلسات </li>';
                desc += '<li>   برندینگ اختصاصی </li>';

            }

            if (ptype.type == "WEDOMEET_UNLIMITED") {
                desc += '<li>   تمامی امکانات سیستم </li>';
                desc += '<li>    زمان برگزاری  <strong> نامحدود </strong> </li>';
                desc += '<li>    <strong> 3 وبکم</strong> فعال </li>';
                desc += '<li>   زمانبندی جلسات </li>';

            }

            desc = $sce.trustAsHtml(desc);

            return desc;


        }

        function loadEventSubscriptionTypeList(type) {
            vm.availablePackagePeriods = [];
            switch (type) {
                case "WEBINAR":
                    vm.subscriptionTypeList = [{type: 'WEBINAR_BASIC', packages: '', isSelected: false},
                        {type: 'WEBINAR_STANDARD', packages: '', isSelected: false},
                        {type: 'WEBINAR_PRO', packages: '', isSelected: false}];
                    break;
                case "CONFERENCE":
                    vm.subscriptionTypeList = [{type: 'CONFERENCE_BASIC', packages: '', isSelected: false},
                        {type: 'CONFERENCE_STANDARD', packages: '', isSelected: false},
                        {type: 'CONFERENCE_PRO', packages: '', isSelected: false}];
                    break;
                case "UNLIMITED":
                    vm.subscriptionTypeList = [{type: 'WEDOMEET_UNLIMITED', packages: '', isSelected: false}];
                    break;
            }

        }

        function loadSubscriptionPackages(pType) {
            if (!vm.selectedSubscriptionType)
                return;

            SubscriptionPackageCustom.getSubscriptionPackageByType(vm.selectedSubscriptionType).query().$promise.then(function (result) {
                vm.subscriptionPackages = result;

                vm.availablePackagePeriods = result;

                vm.availablePackagePeriods.sort(
                    function (a, b) {
                        if (a.durationDays > b.durationDays)
                            return 1;
                        if (a.durationDays < b.durationDays)
                            return -1;
                        if (a.durationDays == b.durationDays) {

                            if (a.id > b.id)
                                return 1;
                            if (a.id < b.id)
                                return -1;
                        }
                        return 0;

                    }
                );

            });
        }

    }
})();
